import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { Purpose } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { useMemo } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import { initialPurposeOptions } from '../../config/globals';
import { PurposeFormGroupData } from '../../FormData.se.types';

export const InitialPurpose = () => {
  const { t } = useTranslation();

  const { setValue, watch } = useFormContext();

  const purpose = watch('LoanApplication/Purpose');

  const initialPurposeRegisterOptions: RegisterOptions = useMemo(
    () => ({
      required: 'InitialPurpose.error.required',
      onChange: (e) => {
        if (!purpose && e.target.value === Purpose.Other) return;
        setValue('LoanApplication/Purpose', e.target.value, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });

        if (purpose && e.target.value === Purpose.RefinancingLoan) {
          setValue('Frontend/PurposeDropdown', null, {
            shouldDirty: true,
            shouldTouch: true,
          });
        }
      },
    }),
    [setValue, purpose]
  );

  return (
    <RadioFieldUI<PurposeFormGroupData>
      name="LoanApplication/InitialPurpose"
      label={t('InitialPurpose.label')}
      data-testid="refinancing-radio"
      radioStyle="both"
      options={initialPurposeOptions}
      registerOptions={initialPurposeRegisterOptions}
    />
  );
};
